/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CloseBlack, LinkIcon, LostItemDate, LostItemFilter, LostItemSt, TableSearch } from "../../common/svg/AllSvg";
import NoSearch from "../../common/form/NoSearch";
import EmptyList from "../../common/form/EmptyList";
import moment from "moment";
import { Link } from "react-router-dom";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";
import { useSelector } from "react-redux";
import PaginationComponent from "../../common/form/PaginationComponent";
import Error from "../../common/form/Error";

const LostItem = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const { t } = useTranslation('common');
    const [data, setData] = useState<any[]>([1, 2])
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [searchFocus, setSearchFocus] = useState<boolean>(false)
    const [detail, setDetail] = useState<boolean>(false)
    const [page, setPage] = useState<number>(1);
    const [itemDetail, setItemDetail] = useState<any>(null)
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    const loaderData: any[] = [1, 2, 3, 4, 5]
    let totalPages: number = Math.ceil(total / +size?.value);
    const ref: any = useRef();

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDetail(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);

    document.onkeydown = function (evt: any) {
        if (evt.keyCode === 27) {
            setDetail(false)
        }
    };

    useEffect(() => {
        if (detail) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [detail]);

    const getLostItem = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url.lost_item}?page=${page}&size=${+size?.value}&search=${debouncedValue}`);

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setTotal(res?.data?.count)
                setLoading(false)
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching lost item", error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getLostItem();
    }, [page, size, debouncedValue])

    return (
        <>
            <div className="flex flex-col w-full">
                <div className="flex flex-col gap-[5px] w-full pb-[20px] px-[15px] md:p-[30px] xlx:p-[35px] border-b border-primary border-opacity-[0.2]">
                    <h3 className="text-primaryText dark:text-white font-semibold">{t("profile.tabs.lost_item")}</h3>
                    <h6 className="text-blackDull dark:text-textBlackDull font-medium xsm:max-w-max max-w-[200px]">{t("profile.lost_item_desc")}</h6>
                </div>

                <div className="w-full h-full flex flex-col gap-[20px] items-center justify-center py-[20px] px-[15px] md:p-[30px] xlx:px-[35px]">
                    {(!!search || data?.length > 0) && <div className="flex w-full justify-end items-center gap-[10px]">
                        <div className={`border border-[rgba(134,134,134,0.15)] h-[35px] xlx:h-[40px] px-[12px] xlx:px-[15px] flex items-center gap-[7px] xlx:gap-[9px] rounded-[6px] w-full xsm:w-[280px] xlx:w-[315px] ${searchFocus && "shadow-xl"} hover:shadow-xl`}>
                            <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-primary" />
                            <input type="text" className="text-blackDull font-semibold placeholder:text-blackDull text-sm leading-tight w-full bg-transparent dark:text-textBlackDull placeholder:dark:text-textBlackDull" placeholder={t("grievance.home.banner.search")} autoComplete="off" value={search} onChange={(e: any) => { setSearch(e.target.value) }} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                        </div>

                        <button className="bg-[#F6F6F6] border border-[#DDE2E4] dark:bg-bgDarkDull dark:border-primary rounded-[6px] h-[34px] xlx:h-[39px] min-w-[34px] xlx:min-w-[39px] flex items-center justify-center focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]">
                            <LostItemFilter className="fill-primary" />
                        </button>
                    </div>}

                    {loading ?
                        <div className="grid gap-[15px] w-full h-full grid-cols-1 msm:grid-cols-2 xl:grid-cols-3">
                            {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                <div key={index} className="p-[15px] xlx:p-[20px] flex flex-col gap-[8px] xlx:gap-[10px] w-full border border-gray-200 dark:border-gray-700 shadow rounded-[10px] animate-pulse">
                                    <div className="w-[70px] h-[25px] bg-gray-200 rounded-[7px] dark:bg-gray-700"></div>
                                    <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>

                                    <div className="flex items-center gap-[10px] flex-wrap">
                                        <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        <>
                            {isError ?
                                <Error />
                                : <>
                                    {data?.length > 0 && <>
                                        <div className="grid gap-[15px] w-full h-full grid-cols-1 msm:grid-cols-2 xl:grid-cols-3">
                                            {Array.isArray(data) && data?.map((item: any, index: number) => (
                                                <button className="bg-[#F6F9FC] dark:bg-[#373840] hover:bg-white focus:bg-white rounded-[10px] hover:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)] focus:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)] p-[15px] xlx:p-[20px] flex flex-col gap-[8px] xlx:gap-[10px] w-full dark:hover:shadow-[0px_8px_28px_-6px_#ffffff5e] dark:focus:shadow-[0px_8px_28px_-6px_#ffffff5e]" key={index} onClick={() => { setDetail(true); setItemDetail(item) }}>
                                                    <h6 className="bg-[#FFE2D9] rounded-[7px] px-[7px] flex items-center justify-center h-[25px] leading-tight text-primaryText font-semibold">{item?.category?.name}</h6>
                                                    <h5 className="text-primaryText dark:text-white font-bold pt-[5px] text-left">{item?.item_name}</h5>

                                                    <div className="flex items-center gap-[10px]">
                                                        <div className="flex items-center gap-[8px]">
                                                            <div className="mt-[2px]">
                                                                <LostItemDate />
                                                            </div>
                                                            <h6 className="text-blackDull dark:text-textBlackDull font-semibold">{moment(item?.item_lost_date).format('DD MMM')}</h6>
                                                        </div>

                                                        <div className="flex items-center gap-[8px]">
                                                            <LostItemSt />
                                                            <h6 className="text-blackDull dark:text-textBlackDull font-semibold">{(!!item?.station && Object?.keys(item?.station)?.length > 0) ? (item?.station?.name) : (!!item?.from_station && Object?.keys(item?.from_station)?.length > 0) ? item?.to_station?.name : (!!item?.to_station && Object?.keys(item?.to_station)?.length > 0) ? item?.to_station?.name : "-"}</h6>
                                                        </div>
                                                    </div>
                                                </button>
                                            ))}
                                        </div>

                                        <div className="flex items-center justify-center w-full mt-[10px]">
                                            <PaginationComponent
                                                page={page}
                                                total={totalPages}
                                                setPage={setPage}
                                            />
                                        </div>
                                    </>}

                                    {((!!!search) && data?.length === 0) &&
                                        <EmptyList />
                                    }

                                    {((!!search) && data?.length === 0) &&
                                        <NoSearch onClick={() => { setSearch("") }} />
                                    }
                                </>}
                        </>}
                </div>
            </div>

            <>
                {detail &&
                    <div className="fixed inset-0 z-[34] top-0 w-full h-full overflow-y-auto bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]">
                        <div className="flex justify-center items-center min-h-screen">
                            <div className="m-[15px] mm:mx-auto w-full sm:w-[600px] md:w-[700px] msm:w-[717px] h-auto relative bg-white dark:bg-bgDarkDull rounded-[10px] shadow-[0px_8px_22px_-6px_rgba(24,39,75,0.12),0px_14px_64px_-4px_rgba(24,39,75,0.12)]" ref={ref}>

                                <div className="w-full flex justify-between gap-[15px] p-[20px]">
                                    <h4 className="text-primaryText dark:text-white font-bold">{itemDetail?.item_name}</h4>

                                    <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="w-[25px] h-[25px] rounded-full focus:shadow-[0_0_0_2px_#4145525e] hover:shadow-[0_0_0_2px_#4145525e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" type="button" onClick={() => setDetail(false)}>
                                        <CloseBlack />
                                    </button>
                                </div>

                                <div className="p-[20px] !pt-0 w-full h-full">
                                    <div className="w-full h-full bg-[#D9D9D9] bg-opacity-[0.2] rounded-[15px] py-[18px] px-[22px] flex flex-col gap-[15px]">
                                        <div className="flex gap-[35px] flex-wrap">
                                            <div className="flex flex-col items-start gap-[4px]">
                                                <p className="font-medium text-blackDull dark:text-textBlackDull">{t("passenger.lost_found.report_form.form.category")}</p>
                                                <h6 className="text-primaryText dark:text-white font-semibold capitalize">{itemDetail?.category?.name}</h6>
                                            </div>

                                            <div className="flex flex-col items-start gap-[4px]">
                                                <p className="font-medium text-blackDull dark:text-textBlackDull">{t("passenger.lost_found.report_form.form.quantity")}</p>
                                                <h6 className="text-primaryText dark:text-white font-semibold">{itemDetail?.quantity}</h6>
                                            </div>

                                            <div className="flex flex-col items-start gap-[4px]">
                                                <p className="font-medium text-blackDull dark:text-textBlackDull">{t("passenger.lost_found.report_form.form.date")}</p>
                                                <h6 className="text-primaryText dark:text-white font-semibold">{moment(itemDetail?.item_lost_date).format('DD MMM YYYY')}</h6>
                                            </div>

                                            <div className="flex flex-col items-start gap-[4px]">
                                                <p className="font-medium text-blackDull dark:text-textBlackDull">{t("passenger.lost_found.report_form.form.lost_item_while")}</p>
                                                <h6 className="text-primaryText dark:text-white font-semibold capitalize">{itemDetail?.metro_or_station}</h6>
                                            </div>
                                        </div>

                                        <div className="flex flex-col items-start gap-[4px] mt-[10px]">
                                            <p className="font-medium text-blackDull dark:text-textBlackDull">{t("passenger.lost_found.list.desc")}</p>
                                            <h6 className="text-primaryText dark:text-white font-semibold">{itemDetail?.description}</h6>
                                        </div>

                                        {(!!itemDetail?.item_image && Object?.keys(itemDetail?.item_image)?.length > 0) && <Link to={itemDetail?.item_image?.file} target="_blank" className="rounded-[5px] border border-[#BEF7FF] bg-[#E5FFFD] px-[9px] py-[5px] gap-[6px] flex  font-semibold text-blackDull w-fit text-sm !leading-tight focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] dark:bg-bgDark dark:border-[#777777] dark:text-textBlackDull break-all">
                                            <LinkIcon className="xlx:min-w-[10px] xlx:w-[10px] xlx:h-[16px] min-w-[9px] w-[9px] h-[15px] fill-blackDull dark:fill-textBlackDull" />
                                            {itemDetail?.item_image?.file_details?.name}.{itemDetail?.item_image?.file_details?.type}
                                        </Link>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >}
            </>
        </>
    );
};

export default LostItem;